export default {
    primaryColor: '#083D77',
    accentColor: '#FF801E',
    // Add more colors as needed...
};